import { v4 as uuidv4 } from 'uuid';

export const UNREGISTERED_USER_PREFIX = 'UNREGISTERED';

export const generateUuidForUnregisteredUser = () => `${UNREGISTERED_USER_PREFIX}#${uuidv4()}`;
